import { useEffect, useState } from 'react';
import {
  useCalendarStore,
  useHabitStore,
  useRoutineStore,
  useSubscriptionStore,
  useTaskStore,
  useUIStore,
  useUserPatternStore,
} from '@/stores';

const persistStores = [
  useTaskStore,
  useRoutineStore,
  useHabitStore,
  useCalendarStore,
  useUserPatternStore,
  useUIStore,
  useSubscriptionStore,
] as const;

export const useHydration = (): boolean => {
  const [hydrated, setHydrated] = useState(() =>
    persistStores.every((s) => s.persist.hasHydrated()),
  );

  useEffect(() => {
    if (hydrated) return;
    const flags = persistStores.map((s) => s.persist.hasHydrated());
    const check = () => {
      if (flags.every(Boolean)) setHydrated(true);
    };
    const unsubs = persistStores.map((s, i) =>
      s.persist.onFinishHydration(() => {
        flags[i] = true;
        check();
      }),
    );
    check();
    return () => {
      for (const u of unsubs) u();
    };
  }, [hydrated]);

  return hydrated;
};
